const groupBy = <T, K extends keyof any>(
  arr: T[],
  callback: (item: T, index: number, array: T[]) => K
): Record<K, T[]> => {
  return arr.reduce((acc: Record<K, T[]>, item: T, index: number, array: T[]) => {
    const key = callback(item, index, array);
    acc[key] ??= [];
    acc[key].push(item);
    return acc;
  }, {} as Record<K, T[]>);
};
export default groupBy;
